<div
  [formGroup]="form"
  class="columns-wrapper"
>
  <div class="items-column">
    <app-listbox
      #optionsListbox
      [filter]="true"
      [filterPlaceholder]="sourceFilterPlaceholder"
      [multiple]="true"
      [options]="availableItems"
      [showToggleAll]="false"
      [sort]="sort"
      (onDblClick)="addItemsToSelected($event.value)"
      (onFilter)="clearValue('availableItemsSelection')"
      formControlName="availableItemsSelection"
      class="listbox"
    >
    </app-listbox>
  </div>
  <div class="buttons-column">
    <button
      [disabled]="form.get('selectedItemsSelection').disabled || !availableItems.length"
      (click)="addAllAvailableToSelected()"
      data-qa="picklist-add-all-from-selected-button"
      type="button"
      class="pick-button pick-button-right-all proget-button icon-only pick-icon-container"
    >
      <i class="chevron-double-right"></i>
    </button>
    <button
      [disabled]="!canMoveSelection('availableItemsSelection')"
      (click)="addSelectionToSelected()"
      data-qa="picklist-add-selection-to-selected-button"
      type="button"
      class="pick-button pick-button-right proget-button icon-only pick-icon-container"
    >
      <i class="chevron-right"></i>
    </button>
    <button
      [disabled]="!canMoveSelection('selectedItemsSelection')"
      (click)="removeSelectionFromSelected()"
      data-qa="picklist-remove-selection-from-selected-button"
      type="button"
      class="pick-button pick-button-left proget-button icon-only pick-icon-container"
    >
      <i class="chevron-left"></i>
    </button>
    <button
      [disabled]="form.get('selectedItemsSelection').disabled || !selectedItems.length"
      (click)="removeAllFromSelected()"
      data-qa="picklist-remove-all-from-selected-button"
      type="button"
      class="pick-button pick-button-left-all proget-button icon-only pick-icon-container"
    >
      <i class="chevron-double-left"></i>
    </button>
  </div>
  <div class="items-column">
    <app-listbox
      #selectedListbox
      [filter]="true"
      [filterPlaceholder]="targetFilterPlaceholder"
      [multiple]="true"
      [options]="selectedItems"
      [sort]="sort"
      (onDblClick)="removeItemsFromSelected($event.value)"
      (onFilter)="clearValue('selectedItemsSelection')"
      formControlName="selectedItemsSelection"
      class="listbox"
    >
    </app-listbox>
  </div>
</div>
